import type { Language } from '@repo/constants'
import { useTranslation } from 'react-i18next'

/**
 * The regionalised tag to hand to `Intl`, as opposed to the bare language code
 * {@link import('./useLocale').useLocale} returns.
 *
 * `i18n.language` is only ever `'en'` or `'fr'`, and `Intl` resolves a bare `'fr'` to France —
 * which groups with a narrow no-break space and writes CAD as `$CA`. Canadian French wants a
 * no-break space and a plain `$`.
 *
 * Scoped to `NumberField`'s callers for now. Correcting `useLocale` itself shifts every currency,
 * number and date format across its ~130 call sites and deserves its own change.
 */
const INTL_LOCALE: Record<Language, string> = {
  en: 'en-CA',
  fr: 'fr-CA',
}

export function useIntlLocale() {
  const { i18n } = useTranslation()
  return INTL_LOCALE[i18n.language as Language] ?? INTL_LOCALE.en
}
